/**
 * Is emri detayindaki "Atanmis Personel" tabinin personel karti.
 *
 * Karta is #1903 ile "Is Emrine Harcanan Sure" alani eklendi. Alanin ACILIP acilmayacagina
 * SUNUCU karar veriyor (`user.IsSpentMinutesEditable`): sahiplik, is emrinin statusu ve
 * "WorkOrder ve Incident Sure Duzenleme" yetkisi orada birlikte degerlendiriliyor. Kural burada
 * TEKRARLANMIYOR - iki tarafta iki kopya kural, ilk ayrisan gunde kullaniciya gorunen ama
 * sunucunun reddettigi bir dugme demek.
 *
 * Kilit ayri bir kapi ve bayrakta yok: `locked` prop'u ile disaridan geliyor.
 */
export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
    // Is emri saha uygulamasinda kilitliyse kimse yazamaz - yetkili de.
    locked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Tek durum: null = duzenlemede degil. Ayrica bir `isEditing` bayragi tutmak, ikisinin
      // ayrisabildigi bir durum yaratirdi.
      draftMinutes: null,
    };
  },
  computed: {
    isEditing() {
      return this.draftMinutes !== null;
    },
    canEdit() {
      return !this.locked && this.user.IsSpentMinutesEditable === true;
    },
    spentText() {
      const minutes = this.user.SpentMinutes;
      return minutes === null || minutes === undefined
        ? this.translate('spent_time_not_entered')
        : `${minutes} ${this.translate('abbreviation_minute')}`;
    },
    // Girdi `type=number min=0 step=1`; geriye yalnizca "bos birakilmasin" kaliyor.
    canSave() {
      return this.draftMinutes !== null && this.draftMinutes !== '' && Number(this.draftMinutes) >= 0;
    },
  },
  methods: {
    startEdit() {
      const current = this.user.SpentMinutes;
      this.draftMinutes = current === null || current === undefined ? '' : current;
    },
    cancel() {
      this.draftMinutes = null;
    },
    save() {
      if (!this.canSave) return;

      this.$emit('save-spent-minutes', {
        userId: this.user.Id,
        spentMinutes: Number(this.draftMinutes),
      });
      this.draftMinutes = null;
    },
  },
};
